import React from 'react';

import {StdBox, TextBT} from './styles';

const Button = ({text, handle}) => {
  return (
    <>
      <StdBox
      onClick={handle}
      >
        <TextBT>{text}</TextBT>
      </StdBox>
    </>
  );
};
export default Button;
